import { ToggleLabelPosition } from '@capsicum/common';
import { BaseSearchInput, BaseToggleInput, ChipList, type ChipListItem, Text } from '@capsicum/common-web';
import styled from 'styled-components';

export type SearchSectionProps = {
	filters: Array<ChipListItem>;
	handleFilterChange: (selected: Array<string>) => void;
	isShowAvailableOnly: boolean;
	searchPlaceholder: string;
	selectAllCheckboxLabel: string;
	selectedTeamsCountText: string;
	setIsShowAvailableOnly: (value: boolean) => void;
	setSearchText: (text: string) => void;
	title: string;
	toggleLabel: string;
};

export const WCPledgeSearchSection = ({
	filters,
	handleFilterChange,
	isShowAvailableOnly,
	searchPlaceholder,
	selectAllCheckboxLabel,
	selectedTeamsCountText,
	setIsShowAvailableOnly,
	setSearchText,
	title,
	toggleLabel
}: SearchSectionProps) => {
	return (
		<S.SearchSection>
			<Text variant="text9">{title}</Text>
			<BaseSearchInput
				debounceTime={250}
				placeholder={searchPlaceholder}
				testID="wcpledge-tokens-tab-search-input"
				onChange={e => setSearchText(e.target.value)}
			/>
			<ChipList
				allButton={false}
				hasWrapper={false}
				items={filters}
				itemsSelected={handleFilterChange}
				selectionType="single"
				testID="wcpledge-tokens-tab-chip-list"
			/>
			<S.SpaceBetweenRow>
				<BaseToggleInput
					label={toggleLabel}
					labelPosition={ToggleLabelPosition.AFTER}
					testID="wcPledge-tokensTab-showAvailableToggle"
					value={isShowAvailableOnly}
					onChange={setIsShowAvailableOnly}
				/>
				<Text testID="wcpledge-selected-teams-counter-text" variant="text4">
					{`${selectedTeamsCountText} ${selectAllCheckboxLabel}  `}
				</Text>
			</S.SpaceBetweenRow>
		</S.SearchSection>
	);
};

namespace S {
	export const SearchSection = styled.div`
		display: flex;
		flex-direction: column;
		gap: ${({ theme }) => theme.spacings.small};
	`;

	export const SpaceBetweenRow = styled.div`
		display: flex;
		justify-content: space-between;
		align-items: center;
		gap: ${({ theme }) => theme.spacings.xxsmall};
	`;
}
